import { VenueAreas } from 'components/VenueAreas/VenueAreas'
import { NextPage } from 'next'
import React from 'react'

const NachosCantina: NextPage = () => {
  return (
    <VenueAreas
      name="Nachos Cantina"
      areas={[
        {
          title: 'Aspendale',
          image: '/static/avc/nachoscantina-asp.jpg',
          venueSlug: 'nachoscantina-asp',
        },
        {
          title: 'Mt. Waverley',
          image: '/static/avc/nachoscantina-mw.jpg',
          venueSlug: 'nachoscantina-mw',
        },
      ]}
    />
  )
}

export default NachosCantina
